import { useRef, useState } from "react";
import { getOwnerDocument as u } from "../utils/owner.js";
import { useDisposables as p } from "./use-disposables.js";
import { useEvent as o } from "./use-event.js";
function E(e) {
  let t = e.width / 2, n = e.height / 2;
  return { top: e.clientY - n, right: e.clientX + t, bottom: e.clientY + n, left: e.clientX - t };
}
function P(e, t) {
  return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function w({ disabled: e = false } = {}) {
  let t = useRef(null), [n, l] = useState(false), r = p(), o$1 = o(() => {
    t.current = null, l(false), r.dispose();
  }), f = o((s) => {
    if (r.dispose(), t.current === null) {
      t.current = s.currentTarget, l(true);
      {
        let i = u(s.currentTarget);
        r.addEventListener(i, "pointerup", o$1, false), r.addEventListener(i, "pointermove", (c) => {
          if (t.current) {
            let p2 = E(c);
            l(P(p2, t.current.getBoundingClientRect()));
          }
        }, false), r.addEventListener(i, "pointercancel", o$1, false);
      }
    }
  });
  return { pressed: n, pressProps: e ? {} : { onPointerDown: f, onPointerUp: o$1, onClick: o$1 } };
}
export {
  w as useActivePress
};
